if (!customElements.get('milk-product')) {
  class MilkProduct extends HTMLElement {
    constructor() {
      super();

      this.product = JSON.parse(this.dataset.product);
      this.variantInput = this.querySelector('[data-variant-id]');
      this.priceEl = this.querySelector('[data-price]');
      this.currentOptions = {};
      this.hasUserInteracted = false;  // NEW
    }

    connectedCallback() {
      this.bindOptionButtons();
      this.selectInitialOptions();
      this.updateVariant();
    }

    bindOptionButtons() {
      this.querySelectorAll('[data-color-swatch], [data-option-button]')
        .forEach(btn => {
          btn.addEventListener('click', () => {
            const name = btn.dataset.optionName;
            const value = btn.dataset.optionValue;

            this.currentOptions[name] = value;

            this.setSelected(name, value);

            if (btn.dataset.variantImage) {
              this.hasUserInteracted = true;   // NEW
              this.swapHero(btn.dataset.variantImage);
            }

            this.updateVariant();
          });
        });
    }

    setSelected(name, value) {
      this.querySelectorAll(`[data-option-name="${name}"]`).forEach(el => {
        el.dataset.selected = el.dataset.optionValue === value;
      });
    }

    selectInitialOptions() {
      const variant =
        this.product.variants.find(v => v.available) ||
        this.product.variants[0];

      this.product.options.forEach((name, idx) => {
        const value = variant[`option${idx + 1}`];
        this.currentOptions[name] = value;
        this.setSelected(name, value);
      });

      if (this.variantInput)
        this.variantInput.value = variant.id;

      if (this.priceEl)
        this.priceEl.textContent = `$${(variant.price / 100).toFixed(2)}`;
    }

    updateVariant() {
      const variant = this.product.variants.find(v => {
        return this.product.options.every((name, idx) =>
          v[`option${idx + 1}`] === this.currentOptions[name]
        );
      });

      if (!variant) return;

      this.variantInput.value = variant.id;
      this.priceEl.textContent = `$${(variant.price / 100).toFixed(2)}`;

      this.updateAvailability();
      this.updateATCState(variant);
    }

    updateAvailability() {
      const opts = this.product.options;

      opts.forEach(name => {
        const buttons = this.querySelectorAll(
          `[data-option-button][data-option-name="${name}"],
           [data-color-swatch][data-option-name="${name}"]`
        );

        buttons.forEach(btn => {
          const val = btn.dataset.optionValue;

          const match = this.product.variants.find(v => {
            return opts.every((optName, idx) => {
              if (optName === name)
                return v[`option${idx + 1}`] === val;
              return v[`option${idx + 1}`] === this.currentOptions[optName];
            });
          });

          const isAvailable = match && match.available;

          btn.style.opacity = isAvailable ? "1" : "0.5";
          btn.dataset.available = isAvailable ? "true" : "false";
        });
      });
    }

    updateATCState(variant) {
      const atc = this.querySelector('[data-atc]');
      const text = atc.querySelector('span');

      if (!variant.available) {
        atc.setAttribute('disabled', 'disabled');
        atc.setAttribute('aria-disabled', 'true');
        text.textContent = 'Sold Out';
      } else {
        atc.removeAttribute('disabled');
        atc.removeAttribute('aria-disabled');
        text.textContent = 'Add to cart';
      }
    }

    swapHero(src) {
      // Skip on initial load only
      if (!this.hasUserInteracted) return;

      const heroes = this.querySelectorAll('[data-hero]');
      if (!heroes.length || !src) return;

      heroes.forEach(img => img.style.opacity = 0);

      const preload = new Image();
      preload.onload = () => {
        heroes.forEach(img => {
          img.src = src;
          img.style.opacity = 1;
        });
      };
      preload.src = src;
    }
  }

  customElements.define('milk-product', MilkProduct);
}
